/**
 * APT355: the text of an accounting period in a dropdown or a list. A client with no accounting period showed "null to undefined" (the
 * shared Select hands its label function an empty item when the screen holds an empty period id), so the label never prints a missing
 * date as the word undefined or null: with neither date it is empty (the dropdown's placeholder shows instead), with one date it is
 * that date alone.
 */

/** What an empty period dropdown says. */
export const NO_PERIOD_PLACEHOLDER = 'Accounting period';

/** What a screen that has nothing to show without a period says (under the dropdown). */
export const NO_PERIOD_NOTE = 'This client has no accounting period yet. Add one under Settings, Accounting Periods.';

const present = (value: unknown): string => (value === null || value === undefined ? '' : String(value).trim());

/** "from to to" / "from - to" for the two dates a period has; a missing date is left out, and none at all gives ''. */
export function periodRangeText(from: unknown, to: unknown, separator: string): string {
  const start = present(from);
  const end = present(to);
  if (start && end) return `${start}${separator}${end}`;
  return start || end;
}
